/* eslint-disable require-jsdoc */
import React from 'react';
import {Skeleton} from '@mui/material';

function PostLoading() {
  return (
    <div>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
      <Skeleton animation="wave" width={700} height={310}
        style={{marginTop: '-55px'}}>
      </Skeleton>
    </div>
  );
}

export default PostLoading;
